import { createContext } from 'react';

export const CanvasContext = createContext({
	context: undefined
});
